export default [
  {
    header: 'Patient Info',
    icon: 'GridIcon',
    route: 'patient-info',
    title: 'Patient Info'
  },
]
